import axios from 'axios';
import { useCallback } from 'react';

import { configSetting } from '../config';
import { HttpConfig } from '../models/https';

const useFileDownloader = () => {
    const downloadFile = useCallback(async (httpConfig: HttpConfig,
        callback: (data: any) => void,
        loadingFunc?: (value: boolean) => void,
        errorFunc?: (err: any) => void,
        downloadName: string = "download"
    ) => {

        const apiUrl = `${configSetting.apiUrl}${httpConfig.url}`;

        const config = {
            ...httpConfig,
            url: apiUrl,
            responseType: 'blob' as const,
            headers: {
                'Content-Type': 'application/json',
                ...httpConfig.headers,
            },
        };

        try {
            if (loadingFunc) {
                loadingFunc(true);
            }
            const response = await axios(config);
            const url = URL.createObjectURL(response.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = downloadName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            callback(response.data);
        } catch (err: any) {
            if (errorFunc) {
                errorFunc(err);
            }
            if (loadingFunc) {
                loadingFunc(false);
            }
        } finally {
            if (loadingFunc) {
                loadingFunc(false);
            }
        }
    }, []);

    return downloadFile;
};


export default useFileDownloader;
